import { render, staticRenderFns } from "./virtualView.vue?vue&type=template&id=4216e852"
import script from "./virtualView.vue?vue&type=script&lang=js"
export * from "./virtualView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports